<script setup>
defineProps({ includeZoom: { default: false, type: Boolean } })

defineEmits(['click:recenter', 'click:rotateLeft', 'click:rotateRight', 'click:zoomIn', 'click:zoomOut'])
</script>

<template>
  <v-row
    class="position-absolute ma-2 justify-center"
    style="bottom: 0; right: 0"
    no-gutters
    dense
  >
    <v-btn
      v-if="includeZoom"
      class="ma-1 rounded-pill"
      variant="elevated"
      icon="mdi-magnify-minus"
      @click="$emit('click:zoomOut')"
    />

    <v-btn
      v-if="includeZoom"
      class="ma-1 rounded-pill"
      variant="elevated"
      icon="mdi-magnify-plus"
      @click="$emit('click:zoomIn')"
    />
    <v-btn
      class="ma-1 rounded-pill"
      variant="elevated"
      icon="mdi-rotate-left"
      @click="$emit('click:rotateLeft')"
    />
    <v-btn
      class="ma-1 rounded-pill"
      variant="elevated"
      icon="mdi-home"
      @click="$emit('click:recenter')"
    />
    <v-btn
      class="ma-1 rounded-pill"
      variant="elevated"
      icon="mdi-rotate-right"
      @click="$emit('click:rotateRight')"
    />
  </v-row>
</template>

<style scoped>

</style>
